import { Helpers } from '@utils/helpers';
import { get } from 'lodash';

export class PageLayerObject {
  brand: string;
  country: string;
  errorCode: string;
  errorMessage: string;
  language: string;
  navLevel1: string;
  navLevel2: string;
  navLevel3: string;
  navLevel4: string;
  navLevel5: string;
  siteID: string;
  type: string;
  // Journey step identifiers (QB-AA-Tracking fix): pushed on every trackPageLoad so
  // Adobe Analytics can tell distinct MLTC steps apart instead of relying on form
  // name alone, which was causing steps to overlap/mismatch in reporting.
  journeyName: string;
  stepName: string;
  stepNumber: string;
  constructor(initital: any) {
    this.brand = get(initital, 'brand', 'aviva');
    this.country = get(initital, 'country', 'sg');
    this.errorCode = get(initital, 'errorCode', '');
    this.errorMessage = get(initital, 'errorMessage', '');
    this.language = get(initital, 'language', 'en-sg');
    this.navLevel1 = get(initital, 'navLevel1', );
    this.navLevel2 = get(initital, 'navLevel2', '');
    this.navLevel3 = get(initital, 'navLevel3', '');
    this.navLevel4 = get(initital, 'navLevel4', '');
    this.navLevel5 = get(initital, 'navLevel5', '');

    const siteID = this.getSideId();
    console.log(siteID);
    this.siteID = get(initital, 'siteID', siteID);
    this.type = get(initital, 'type', Helpers.getPlatform());
    this.journeyName = get(initital, 'journeyName', '');
    this.stepName = get(initital, 'stepName', '');
    this.stepNumber = get(initital, 'stepNumber', '');
  }

  private getSideId(): string {
    const path = window.location.href || '';
    if (path.includes('dpi')) {
      return 'qb-dpi';
    }
    else if (path.includes('mltc')) {
      return 'qb-mltc';
    }
    else if(path.includes('shieldstarter')){
      return 'qb-sss'
    }
    else if(path.includes('evergreen')){
      return 'qb-digitalsaver'
    }else if(path.includes('ccp')) {
      return 'qb-ccpii'
    }
    return  'qb-sio';
  }
}


export class FormLayerObject {
  name: string;
  // QB-AA-Tracking fix: which journey the customer landed in, set once at step 0 (the
  // QR/EB "start quote" modal) - "qr-fast-tracked" | "eb-journey" | "eb-qr-fast-tracked".
  // BAU customers never see that modal, so they get "standard" set at step 1 instead.
  // Optional (not just defaulted) so unrelated flows (ShieldStarter/EverGreen/CCP) that
  // define their own form-layer classes aren't forced to declare this MLTC_R3-only field.
  experience?: string;
  error: {
    fieldLabels: string[];
    messages: string[];
    numErrors: string;
  }
  constructor(initial: any) {
    this.name = get(initial, 'name', '');
    this.experience = get(initial, 'experience', '');
    this.error = get (initial, 'error', {
      fieldLabels: [],
      messages: [],
      numErrors: '0'
    });
  }
}


export class AcquisitionLayerObject {
  insurance: {
    premium: string;
    premiumTerm: string;
    premiumType: string; //Custom proposed
    promocode: string;
    campaignCode: string;
    // QB-AA-Tracking fix: `premium` above is the FULL amount paid across every payment
    // method combined; these three break that total down by method so each can be
    // tracked/reported on separately.
    cpfFirstYearCreditCardAmount: string;
    cpfMediSaveAmount: string;
    creditCardAmount: string;
  }
  customer: {
    marketingOptIn: string;
    servicingMode: string;
    // QB-AA-Tracking fix: whether the customer ended up with a financial adviser
    // ("USER_PREFERRED"/"ARISTOTLE" in Agency.tsx) or not ("NO_AGENT", or the
    // advisor step was skipped entirely for this campaign type).
    financialAdvisorStatus: string;
  }

  product: {
    policyID: string;
    prodID: string;
    prodName: string;
  }

  constructor(initial: any) {
    this.insurance = get(initial, 'insurance', {
      premium: '',
      premiumTerm: '',
      premiumType: '',
      promocode: '',
      campaignCode: '',
      cpfFirstYearCreditCardAmount: '',
      cpfMediSaveAmount: '',
      creditCardAmount: '',
    });
    this.customer = get(initial, 'customer',  {
      marketingOptIn: "",
      servicingMode: "",
      financialAdvisorStatus: "",
    });
    this.product = get(initial, 'product', {
      policyID: '',
      prodID: '',
      prodName: '',
    });
  }

}

export class CtaLayerObject{
  type: string;
  text: string;
  
  constructor(initial: any) {
    this.type = get(initial, 'type','');
    this.text = get(initial, 'text','');
  }
}


export class InternalLayerObject{
  account: {
    id:string;
    role:string;
  }

  constructor(initial:any) {
    this.account = get(initial, 'account', {
      id: '',
      role: '',
    });
  }
};

export class DataLayer {
  public page: PageLayerObject;
  public acquisition: AcquisitionLayerObject; 
  public internal:InternalLayerObject;
  public cta:CtaLayerObject;
  public form: FormLayerObject;
  constructor(initial: any) {
    this.page = get(initial, 'page', '');
    this.cta = get(initial, 'cta', '');
    this.acquisition = get(initial, 'acquisition', '');
    this.internal = get(initial, 'internal', '');
    this.form = get(initial, 'form', '');
  }
}